import type { z } from "zod";
import {
    companyDetailsSwedishZodSchema,
    type CompanyDetailsSwedish,
} from "./company-swedish";

/**
 * Betalningsmottagare
 */
type CompanyDetails = CompanyDetailsSwedish;
const companyDetailsZodSchema: z.ZodSchema<CompanyDetails> =
    companyDetailsSwedishZodSchema;

export { companyDetailsZodSchema };
export type { CompanyDetails };
